import { inject, Injectable, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BasicLayoutRouteDataConfig } from '../models/routes.model';
import { DeviceService } from './device.service';
import { UserDataService } from 'src/data-store/user-data.service';

@Injectable({ providedIn: 'root' })
export class LayoutConfigService {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private deviceService = inject(DeviceService);

  public readonly basicLayoutConfig = signal<BasicLayoutRouteDataConfig | null>(null);
  private userDataService = inject(UserDataService);

  public constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.getChildSnapshotDataAndSetToRoute();
      });
      if(this.deviceService.isNativePlatform) {
        // Capacitor apps does not trigger NavigationEnd on init load so trigger it manualy
        // todo - gitlab issue #126
        this.getChildSnapshotDataAndSetToRoute();
      }
  }

  private getChildSnapshotDataAndSetToRoute() {
    let child: ActivatedRoute | null = this.route;
    while (child.firstChild) {
      child = child.firstChild;
    }

    const data = child?.snapshot?.data;
    if(data?.['authOnly'] && !this.userDataService.loggedUser()) {
      this.setBasicLayoutData(data['authOnly'].authFallback);
    } else {
      this.setBasicLayoutData(data);
    }
    return data;
  }

  private setBasicLayoutData(data: BasicLayoutRouteDataConfig | undefined) {
    if (data) {
      this.basicLayoutConfig.set(data);
    } else {
      this.basicLayoutConfig.set(null);
    }
  }
}